/* tslint:disable */
/* eslint-disable */
/**
 * Exyzt City Config
 * Exyzt City Config
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface GetParkingAreas200Response
 */
export interface GetParkingAreas200Response {
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetParkingAreas200ResponseRowsInner>}
     * @memberof GetParkingAreas200Response
     */
    'rows': Array<GetParkingAreas200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetParkingAreas200ResponseRowsInner
 */
export interface GetParkingAreas200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInner
     */
    'value': string;
    /**
     * 
     * @type {GetParkingAreas200ResponseRowsInnerDoc}
     * @memberof GetParkingAreas200ResponseRowsInner
     */
    'doc'?: GetParkingAreas200ResponseRowsInnerDoc;
}
/**
 * 
 * @export
 * @interface GetParkingAreas200ResponseRowsInnerDoc
 */
export interface GetParkingAreas200ResponseRowsInnerDoc {
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    '_rev'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'creationDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'lastModifiedDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'gracePeriod'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'gracePeriodMax'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'zoneId': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'ticketZoneId'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'timeValidity'?: string;
    /**
     * 
     * @type {GetParkingAreas200ResponseRowsInnerDocPrices}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'prices'?: GetParkingAreas200ResponseRowsInnerDocPrices;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'timeZone'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'freeDay'?: Array<string>;
    /**
     * 
     * @type {GetParkingAreas200ResponseRowsInnerDocWeek}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'week'?: GetParkingAreas200ResponseRowsInnerDocWeek;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'timeReduced'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDoc
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface GetParkingAreas200ResponseRowsInnerDocPrices
 */
export interface GetParkingAreas200ResponseRowsInnerDocPrices {
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200ResponseRowsInnerDocPrices
     */
    'finePrice'?: number;
    /**
     * 
     * @type {Array<GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner>}
     * @memberof GetParkingAreas200ResponseRowsInnerDocPrices
     */
    'vehiculeCategory'?: Array<GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner>;
    /**
     * 
     * @type {Array<GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner>}
     * @memberof GetParkingAreas200ResponseRowsInnerDocPrices
     */
    'pricingCategory'?: Array<GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner>;
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200ResponseRowsInnerDocPrices
     */
    'reducedFinePrice'?: number;
}
/**
 * 
 * @export
 * @interface GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner
 */
export interface GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner {
    /**
     * 
     * @type {string}
     * @memberof GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner
     */
    'categoryId'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner
     */
    'finePrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetParkingAreas200ResponseRowsInnerDocPricesVehiculeCategoryInner
     */
    'reducedFinePrice'?: number;
}
/**
 * 
 * @export
 * @interface GetParkingAreas200ResponseRowsInnerDocWeek
 */
export interface GetParkingAreas200ResponseRowsInnerDocWeek {
    /**
     * 
     * @type {JourSemaine}
     * @memberof GetParkingAreas200ResponseRowsInnerDocWeek
     */
    'Monday'?: JourSemaine;
    /**
     * 
     * @type {JourSemaine}
     * @memberof GetParkingAreas200ResponseRowsInnerDocWeek
     */
    'Tuesday'?: JourSemaine;
    /**
     * 
     * @type {JourSemaine}
     * @memberof GetParkingAreas200ResponseRowsInnerDocWeek
     */
    'Wednesday'?: JourSemaine;
    /**
     * 
     * @type {JourSemaine}
     * @memberof GetParkingAreas200ResponseRowsInnerDocWeek
     */
    'Thursday'?: JourSemaine;
    /**
     * 
     * @type {JourSemaine}
     * @memberof GetParkingAreas200ResponseRowsInnerDocWeek
     */
    'Friday'?: JourSemaine;
    /**
     * 
     * @type {JourSemaine}
     * @memberof GetParkingAreas200ResponseRowsInnerDocWeek
     */
    'Saturday'?: JourSemaine;
    /**
     * 
     * @type {JourSemaine}
     * @memberof GetParkingAreas200ResponseRowsInnerDocWeek
     */
    'Sunday'?: JourSemaine;
}
/**
 * 
 * @export
 * @interface GetParkingSections200Response
 */
export interface GetParkingSections200Response {
    /**
     * 
     * @type {number}
     * @memberof GetParkingSections200Response
     */
    'total_rows': number;
    /**
     * 
     * @type {number}
     * @memberof GetParkingSections200Response
     */
    'offset': number;
    /**
     * 
     * @type {Array<GetParkingSections200ResponseRowsInner>}
     * @memberof GetParkingSections200Response
     */
    'rows': Array<GetParkingSections200ResponseRowsInner>;
}
/**
 * 
 * @export
 * @interface GetParkingSections200ResponseRowsInner
 */
export interface GetParkingSections200ResponseRowsInner {
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInner
     */
    'value': string;
    /**
     * 
     * @type {GetParkingSections200ResponseRowsInnerDoc}
     * @memberof GetParkingSections200ResponseRowsInner
     */
    'doc'?: GetParkingSections200ResponseRowsInnerDoc;
}
/**
 * 
 * @export
 * @interface GetParkingSections200ResponseRowsInnerDoc
 */
export interface GetParkingSections200ResponseRowsInnerDoc {
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    '_id': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    '_rev'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'color': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'parkId': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'ticketParkId': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'creationDate': string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'lastModifiedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetParkingSections200ResponseRowsInnerDoc
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface JourSemaine
 */
export interface JourSemaine {
    /**
     * 
     * @type {number}
     * @memberof JourSemaine
     */
    'startMorning'?: number;
    /**
     * 
     * @type {number}
     * @memberof JourSemaine
     */
    'endMorning'?: number;
    /**
     * 
     * @type {number}
     * @memberof JourSemaine
     */
    'startAfternoon'?: number;
    /**
     * 
     * @type {number}
     * @memberof JourSemaine
     */
    'endAfternoon'?: number;
}

/**
 * CityApi - axios parameter creator
 * @export
 */
export const CityApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the json city config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityConfig: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CityApi - functional programming interface
 * @export
 */
export const CityApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CityApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the json city config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCityConfig(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCityConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CityApi - factory interface
 * @export
 */
export const CityApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CityApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the json city config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCityConfig(options?: any): AxiosPromise<object> {
            return localVarFp.getCityConfig(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CityApi - interface
 * @export
 * @interface CityApi
 */
export interface CityApiInterface {
    /**
     * 
     * @summary Get the json city config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityApiInterface
     */
    getCityConfig(options?: AxiosRequestConfig): AxiosPromise<object>;

}

/**
 * CityApi - object-oriented interface
 * @export
 * @class CityApi
 * @extends {BaseAPI}
 */
export class CityApi extends BaseAPI implements CityApiInterface {
    /**
     * 
     * @summary Get the json city config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CityApi
     */
    public getCityConfig(options?: AxiosRequestConfig) {
        return CityApiFp(this.configuration).getCityConfig(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ParkingApi - axios parameter creator
 * @export
 */
export const ParkingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get the list of parking areas
         * @param {string} cityId siret de la ville
         * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkingAreas: async (cityId: string, includeDocs?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('getParkingAreas', 'cityId', cityId)
            const localVarPath = `/city_{cityId}_ref_fps_metadata/_design/fps_metadata/_view/ZONE_V2`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)

            if (includeDocs !== undefined) {
                localVarQueryParameter['include_docs'] = includeDocs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the list of parking sections
         * @param {string} cityId siret de la ville
         * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkingSections: async (cityId: string, includeDocs?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityId' is not null or undefined
            assertParamExists('getParkingSections', 'cityId', cityId)
            const localVarPath = `/city_{cityId}_ref_fps_metadata/_design/fps_metadata/_view/PARK_V2`
                .replace(`{${"cityId"}}`, encodeURIComponent(String(cityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication api_key required
            await setApiKeyToObject(localVarHeaderParameter, "X-BEARER-TOKEN", configuration)

            if (includeDocs !== undefined) {
                localVarQueryParameter['include_docs'] = includeDocs;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ParkingApi - functional programming interface
 * @export
 */
export const ParkingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ParkingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get the list of parking areas
         * @param {string} cityId siret de la ville
         * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkingAreas(cityId: string, includeDocs?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetParkingAreas200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkingAreas(cityId, includeDocs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the list of parking sections
         * @param {string} cityId siret de la ville
         * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getParkingSections(cityId: string, includeDocs?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetParkingSections200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getParkingSections(cityId, includeDocs, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ParkingApi - factory interface
 * @export
 */
export const ParkingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ParkingApiFp(configuration)
    return {
        /**
         * 
         * @summary Get the list of parking areas
         * @param {string} cityId siret de la ville
         * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkingAreas(cityId: string, includeDocs?: boolean, options?: any): AxiosPromise<GetParkingAreas200Response> {
            return localVarFp.getParkingAreas(cityId, includeDocs, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the list of parking sections
         * @param {string} cityId siret de la ville
         * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParkingSections(cityId: string, includeDocs?: boolean, options?: any): AxiosPromise<GetParkingSections200Response> {
            return localVarFp.getParkingSections(cityId, includeDocs, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ParkingApi - interface
 * @export
 * @interface ParkingApi
 */
export interface ParkingApiInterface {
    /**
     * 
     * @summary Get the list of parking areas
     * @param {string} cityId siret de la ville
     * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingApiInterface
     */
    getParkingAreas(cityId: string, includeDocs?: boolean, options?: AxiosRequestConfig): AxiosPromise<GetParkingAreas200Response>;

    /**
     * 
     * @summary Get the list of parking sections
     * @param {string} cityId siret de la ville
     * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingApiInterface
     */
    getParkingSections(cityId: string, includeDocs?: boolean, options?: AxiosRequestConfig): AxiosPromise<GetParkingSections200Response>;

}

/**
 * ParkingApi - object-oriented interface
 * @export
 * @class ParkingApi
 * @extends {BaseAPI}
 */
export class ParkingApi extends BaseAPI implements ParkingApiInterface {
    /**
     * 
     * @summary Get the list of parking areas
     * @param {string} cityId siret de la ville
     * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingApi
     */
    public getParkingAreas(cityId: string, includeDocs?: boolean, options?: AxiosRequestConfig) {
        return ParkingApiFp(this.configuration).getParkingAreas(cityId, includeDocs, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the list of parking sections
     * @param {string} cityId siret de la ville
     * @param {boolean} [includeDocs] inclus les documents associés à l\&#39;identifiant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParkingApi
     */
    public getParkingSections(cityId: string, includeDocs?: boolean, options?: AxiosRequestConfig) {
        return ParkingApiFp(this.configuration).getParkingSections(cityId, includeDocs, options).then((request) => request(this.axios, this.basePath));
    }
}


